module.exports = __webpack_public_path__ + "static/img/zhongjin.4c61c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/zhongjin.png
// module id = zjmM
// module chunks = 1